<template>
    <label class="xcreate-language-switcher" data-no-localize title="切换系统语言">
        <span class="xcreate-language-switcher__label">语言</span>
        <select v-model="locale" aria-label="系统语言" @change="changeLocale">
            <option value="zh-CN">简体中文</option>
            <option value="en-US">English</option>
        </select>
    </label>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { getLocale, setLocale } from '@/locales/runtime';

const locale = ref(getLocale());
const changeLocale = () => setLocale(locale.value);
const syncLocale = (event) => { locale.value = event.detail.locale; };

onMounted(() => window.addEventListener('xcreate:locale-changed', syncLocale));
onBeforeUnmount(() => window.removeEventListener('xcreate:locale-changed', syncLocale));
</script>

<style scoped>
.xcreate-language-switcher {
    align-items: center;
    display: inline-flex;
    gap: 6px;
    margin-right: 12px;
    white-space: nowrap;
}
.xcreate-language-switcher__label { font-size: 12px; }
.xcreate-language-switcher select {
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.45);
    border-radius: 5px;
    color: inherit;
    cursor: pointer;
    font-size: 12px;
    height: 30px;
    padding: 0 6px;
}
.xcreate-language-switcher option { color: #222; }
</style>
